<template>
  <div class="step-counter">
    <header class="step-counter-header">
      <h5>Step {{ this.currentStep }} of {{ this.totalSteps }}</h5>
    </header>
    <span class="step-counter-dots">
      <span 
        class="step-counter-dot"
        v-for="(step, index) in totalSteps"
        :class="{ 'dot-active' : index + 1 <= currentStep }"
        :key="index"
      ></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormSectionStepCounter',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/Variables.scss';

.step-counter {
  padding-bottom: 1.25rem;
  .step-counter-header {
    display: inline;
    h5 {
      display: inline;
    }
  }
  .step-counter-dots {
    margin-left: .625rem;
    .step-counter-dot {
      background-color: #dfe3e8;
      border-radius: 50%;
      display: inline-block;
      height: 10px;
      margin: 0 .125rem;
      width: 10px;
    }
    .step-counter-dot.dot-active {
      background-color: $green-crack;
    }
  }
}

@media (min-width: 768px) {
  .step-counter {
    align-self: flex-end;
  }
}
</style>
